import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLanguage } from "@/context/LanguageContext";
import { Coffee } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { t } = useLanguage();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const qs = new URLSearchParams(location.search);
    const code = qs.get("code");
    const expectedState = sessionStorage.getItem("oauth_state");
    sessionStorage.removeItem("oauth_state");
    if (!code || qs.get("state") !== expectedState) {
      navigate("/login", { replace: true });
      return;
    }
    api.post("/auth/google", { code, redirect_uri: window.location.origin + "/auth/google" })
      .then((r) => {
        setUser(r.data);
        const tableParam = sessionStorage.getItem("pending_table");
        sessionStorage.removeItem("pending_table");
        const base = r.data.role === "staff" && !tableParam ? "/staff" : "/menu";
        navigate(tableParam ? `${base}?table=${tableParam}` : base, { replace: true, state: { user: r.data } });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3 text-[#4A2C2A]">
        <Coffee className="w-8 h-8 animate-pulse" />
        <span className="text-sm font-medium">{t("loading")}</span>
      </div>
    </div>
  );
}
